import { useQuery } from 'react-apollo'
import { useReorder } from '../Reorder/ReorderProvider/ReorderProvider'
import { GET_PAGINATED_ORDERS } from '../../apollo/orders/orders.graphql'
import { useAuth } from '../AuthProvider/AuthProvider'
import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'

/**
 * Returns boolean based on if previous orders exists
 * @param {Boolean} loading
 * @param {ApolloError} error
 * @param {{ paginatedOrders: { orders: [{}], totalSize: number }}} data
 * @returns {boolean}
 */
export function hasPreviousOrders ({ loading, error, data }) {
  if (loading || error) {
    return false
  }

  return Boolean(data && data.paginatedOrders && data.paginatedOrders.orders.length)
}

/**
 * Hook that returns a user's previous orders from which they can reorder
 * @param {string} query
 * @param {number} limit
 * @returns {{reorderGuid: number, reorderMutation: Function}}
 */
export const useReorderQuery = (query = GET_PAGINATED_ORDERS, limit = 2) => {
  const { authenticated } = useAuth()
  const { restaurantGuid } = useRestaurant()
  const context = useReorder()
  const { loading, error, data, ...queryResponse } = useQuery(query, {
    variables: {
      input: {
        restaurantGuid,
        limit
      }
    },
    skip: !authenticated
  })

  return {
    ...context,
    ...queryResponse,
    loading,
    data,
    error,
    hasReorders: hasPreviousOrders({loading, error, data})
  }
}
